import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const certifikatService = {
    load,loadAll,loadLastYear,save,remove,isci,vrniPoId,loadstcert,
    
};
function isci(isci) {
    const requestOptions = {
        method: 'GET',
        //headers:authHeader(),
        
    };
return fetch(`${Vue.prototype.$config.apiUrl}/javno/certifikat/?isci=${isci}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function vrniPoId(id) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader()
    };
return fetch(`${Vue.prototype.$config.apiUrl}/certifikati/2/${id}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {

            
            return certifikat;
        });
}


function loadstcert(sezona,shema) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/certifikati/zadnjastevilka/${sezona}/${shema}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}

function load(strankaid,sezona,shema) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/certifikati/stranka/${strankaid}/${sezona}/${shema}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function save(certifikat) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/certifikati/`, requestOptions).then(handleResponse);
}


function remove(certifikat) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat`, requestOptions).then(handleResponse);
}

function loadAll(sezona,shema){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/certifikati/?sezona=${sezona}&shema=${shema}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });

}
